import script from "./PowertrainSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PowertrainSection.vue?vue&type=script&setup=true&lang=js"

import "./PowertrainSection.vue?vue&type=style&index=0&id=1ec141e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec141e4"]])

export default __exports__